import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideListChecks = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13 5h8m-8 7h8m-8 7h8M3 17l2 2 4-4M3 7l2 2 4-4"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLucideListChecks);
const Memo = memo(ForwardRef);
export default Memo;
